import { ElementsSelectedsContext } from "@/contexts/ElementsSelects";
import { useEffect, useMemo, useState } from "react"

interface IElementsSelecteds {
    children: React.ReactNode
}

export function ProviderElementsSelecteds({ children }: IElementsSelecteds) {
    const [selecteds, setSelecteds] = useState<(number | string)[]>([]);

    const selectedsAll = (data: any[], key: string) => {
        if (data?.length == selecteds?.length) {
            setSelecteds([]);
            return;
        }
        setSelecteds(data?.map(element => element[key]));
    };

    const isSelected = (element: any, key: string) => {
        if (selecteds?.some(el => element[key] == el)) {
            return true
        };
        return false
    };

    const select = (element: any, key: string) => {
        if (selecteds?.some(el => element[key] == el)) {
            const removeArray = selecteds?.filter(el => el != element[key])
            setSelecteds(removeArray);
            return;
        }
        setSelecteds(value => [...value, element[key]]);
    }

    const reset = () => setSelecteds([]);

    const provide = useMemo(() => ({
        select,
        reset,
        isSelected,
        selectedsAll,
        selecteds,
        setSelecteds
    }),
        [selecteds])

    return (
        <ElementsSelectedsContext.Provider value={provide}>
            {children}
        </ElementsSelectedsContext.Provider>
    )
}